import * as React from "react";
import BlockUi from "react-block-ui";

import { bindActionCreators } from "redux";
import { mockTheme, toMap } from "../utils/utils";
import { ComponentClass } from "react";
import { AppDispatch, IStore } from "../store";
import { connect } from "react-redux";

import { RaceActions } from "../store/race/race-actions";
import { RaceState } from "../api/model";
import { IRaceStore } from "../store/race/race-reducer";
import { NotificationActions } from "../store/notification/notification-actions";
import { DriverActions, IDriverStore } from "../store/driver";
import StoreModel from "../store/StoreModel";
import { IConfigStore } from "../store/config";
import { format } from "date-fns";

// components
import RaceListComponent from "../components/race/RaceListComponent";
import DriverLocation from "../components/DriverLocation";

// material
import "react-block-ui/style.css";
import { withStyles } from "@material-ui/core/styles";
import { IconButton, Theme, WithStyles } from "@material-ui/core";
import RefreshIcon from "@material-ui/icons/Cached";
import CloseIcon from "@material-ui/icons/Clear";
import Typography from "@material-ui/core/Typography";
import LinearProgress from "@material-ui/core/LinearProgress";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import SearchBox from "../components/SearchBox";
import TimeIcon from "@material-ui/icons/AccessTime";
// import Icon from "@material-ui/core/Icon";

const styles = (theme: Theme) => ({
  panel: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    marginTop: theme.spacing.unit * 3,
  }),
  icon: {},
  actionHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "row",
  },
});

/**
 * This is a hack to has a object with the keys the same as the return of the #createStyles
 */
const classesType = styles(mockTheme);

interface DashboardProps extends WithStyles<keyof typeof classesType> {
  actions: RaceActions;
  driverActions: DriverActions;
  data: IRaceStore;
  driver: IDriverStore;
  config: IConfigStore;
}

interface DashboardState {
  openMap: boolean;
  driverLocation: any;
  searchText: string;
  racesData: any;
  timeUpdate: any;
  loading: boolean;
}

class Dashboard extends React.Component<DashboardProps, DashboardState> {
  constructor(props: DashboardProps) {
    super(props);

    this.state = {
      openMap: false,
      driverLocation: [],
      searchText: "",
      racesData: [],
      timeUpdate: "",
      loading: false,
    };

    this.loadByState = this.loadByState.bind(this);
  }

  loadByState(state: RaceState) {
    this.props.actions.fetchByState(state);
  }

  changeViewDashboard = (id: number) => {
    const races = this.props.driver.locations.data;
    const filterDriver = races.filter((r) => r.id === id);
    console.log("DATA DE CARRERA filter driver: ", filterDriver);
    this.setState({
      openMap: !this.state.openMap,
      driverLocation: filterDriver,
    });
  };

  filter(search: any) {
    // const s = search === null ? this.state.searchText : search;
    const races = this.props.data.all.data;
    const filterRaces = races.filter((r: any) => r.id === Number(search));
    this.setState({ racesData: filterRaces.length > 0 ? filterRaces : races });
  }

  refreshList() {
    this.props.actions.fetchAll();
    const date = format(new Date(), "HH:mm");
    this.setState({ timeUpdate: date });

    setTimeout(() => {
      this.setState({ racesData: this.props.data.all.data });
    }, 2200);
  }

  componentDidMount() {
    const date = format(new Date(), "HH:mm");
    this.setState({ timeUpdate: date });

    this.props.actions.fetchAll();
    this.setState({ loading: true });
    this.props.driverActions.fetchLocations();
    setTimeout(() => {
      this.setState({ racesData: this.props.data.all.data });
      this.setState({ loading: false });
    }, 2200);
  }

  renderRaceList() {
    if (StoreModel.isLoading(this.props.data.all)) {
      return <LinearProgress />;
    }
    if (StoreModel.isError(this.props.data.all)) {
      return (
        <Typography color="error">
          Error: {this.props.data.resume.error}
        </Typography>
      );
    }

    if (this.state.loading) {
      return <LinearProgress />;
    }

    return (
      <RaceListComponent
        data={this.state.racesData}
        change={this.changeViewDashboard}
        withDriver={true}
      />
    );
  }

  render() {
    const mapActive = this.state.openMap;

    return (
      <Grid container spacing={8}>
        {mapActive ? (
          <Grid item sm={12} md={12} lg={12}>
            <Paper className={this.props.classes.panel} elevation={5}>
              <BlockUi
                tag="div"
                blocking={StoreModel.isLoading(this.props.driver.locations)}
              >
                <Typography variant="headline" component="h3">
                  Ubicación de motista
                  <IconButton
                    className={this.props.classes.icon}
                    aria-label="Refrescar"
                    title="Refrescar"
                    color="primary"
                    onClick={this.props.driverActions.fetchLocations}
                  >
                    <RefreshIcon />
                  </IconButton>
                  <IconButton
                    className={this.props.classes.icon}
                    style={{ float: "right" }}
                    aria-label="Cerrar"
                    title="Cerrar"
                    color="primary"
                    onClick={() => this.changeViewDashboard(0)}
                  >
                    <CloseIcon />
                  </IconButton>
                </Typography>
                <DriverLocation
                  data={this.state.driverLocation}
                  config={this.props.config.data}
                />
              </BlockUi>
            </Paper>
          </Grid>
        ) : (
          <>
            <Grid item sm={12} md={12}>
              <div className={this.props.classes.actionHeader}>
                <SearchBox
                  placeHolder="Ingrese nro. de pedido y presione ENTER"
                  doSearch={(search) => {
                    // this.setState({ searchText: search });
                    this.filter(search);
                  }}
                  hasFilter={false}
                />
              </div>
            </Grid>
            <Grid item sm={12} md={12} lg={12}>
              <Paper className={this.props.classes.panel} elevation={5}>
                <Typography variant="headline" component="h3">
                  Carreras
                  <IconButton
                    className={this.props.classes.icon}
                    aria-label="Refrescar"
                    title="Refrescar"
                    color="primary"
                    onClick={() => this.refreshList()}
                  >
                    <RefreshIcon />
                  </IconButton>
                  <div
                    style={{
                      float: "right",
                      marginTop: 15,
                    }}
                  >
                    <h6>Ultima actualización: {this.state.timeUpdate}</h6>
                  </div>
                  <div style={{ float: "right", marginTop: 10 }}>
                    <TimeIcon color="primary" /> &nbsp;
                  </div>
                </Typography>
                {this.renderRaceList()}
              </Paper>
            </Grid>
          </>
        )}
      </Grid>
    );
  }
}

const mapStateToProps = (
  state: IStore,
  ownProps: DashboardProps
): DashboardProps => ({
  ...ownProps,
  data: state.race,
  driver: state.driver,
  config: state.config,
});

const styled = withStyles(styles as any)(Dashboard);
const connected = connect(mapStateToProps, (dispatch: AppDispatch) => {
  return {
    actions: bindActionCreators(toMap(RaceActions), dispatch),
    driverActions: bindActionCreators(toMap(DriverActions), dispatch),
    notification: bindActionCreators(toMap(NotificationActions), dispatch),
  };
})(styled);

export default connected as ComponentClass<Partial<DashboardProps>>;



// WEBPACK FOOTER //
// ./src/pages/DashboardPage.tsx